'use client';

import { Skeleton } from '@castlery/fortress';

export const ProductInfoSkeleton = () => {
  return <Skeleton />;
};
